module.exports = __webpack_public_path__ + "img/book.8cfcd181.png";